import { useFormik } from "formik";
import React from "react";
import { creditLifeGeneralInfoSchema } from "../../../utils/validators/schema";
import Select from "../../form/select/Select";
import { useEffect } from "react";

const CreditGeneralInformation = ({ getGenerallInfo, coverRef }) => {
  const Currency = ["NGN"];

  const onSubmit = (values) => {
    getGenerallInfo(values);
    coverRef?.current?.click();
  };

  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    setFieldValue,
  } = useFormik({
    initialValues: {
      name: "",
      short_name: "",
      minimun_duration: "",
      currency: "",
      description: "",
    },
    validationSchema: creditLifeGeneralInfoSchema,
    onSubmit,
    validate: (values) => {
      const errors = {};
      if (parseInt(values?.maximum_age) < parseInt(values?.minimum_age)) {
        errors.minMaxAge = "Minimum age cannot be greater than maximum age";
      }
      return errors;
    },
  });

  useEffect(() => {
    getGenerallInfo(values);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values]);

  return (
    <>
      <form className='row' onSubmit={handleSubmit}>
        <div className='col-md-6'>
          <div className='mb-3'>
            <label htmlFor='policy_name' className='form-label'>
              Name <span className='text-danger'>*</span>
            </label>
            <input
              type='text'
              id='name'
              name='name'
              className={`form-control form-control-sm ${
                errors?.name && touched?.name && "text-danger is-invalid"
              }`}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder='Enter Policy Name'
            />
            {errors?.name && touched?.name && (
              <span className='text-danger'>{errors?.name}</span>
            )}
          </div>
        </div>
        <div className='col-md-6'>
          <div className='mb-3'>
            <label htmlFor='short_name' className='form-label'>
              Short Name <span className='text-danger'>*</span>
            </label>
            <input
              id='short_name'
              name='short_name'
              className={`form-control form-control-sm ${
                errors?.short_name &&
                touched?.short_name &&
                "text-danger is-invalid"
              }`}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder='Enter Short Name'
            />
            {errors?.short_name && touched?.short_name && (
              <span className='text-danger'>{errors?.short_name}</span>
            )}
          </div>
        </div>
        <div className='col-md-6'>
          <div className='mb-3'>
            <label htmlFor='simpleinput' className='form-label'>
              Currency <span className='text-danger'>*</span>
            </label>
            <Select
              isError={
                errors?.currency && touched?.currency && !values?.currency
              }
              name='currency'
              data={Currency.map((item, i) => ({
                label: item,
                value: item,
              }))}
              value={values.currency}
              onChange={(selectedOption) =>
                setFieldValue("currency", selectedOption?.value)
              }
              onBlur={() => handleBlur({ target: { name: "currency" } })}
            />
            {errors?.currency && touched?.currency && !values?.currency && (
              <p className='text-danger mb-0'>{errors?.currency}</p>
            )}
          </div>
        </div>
        <div className='col-md-6'>
          <div className='mb-3'>
            <label htmlFor='minimum_duration' className='form-label'>
              Minimum Duration(months)<span className='text-danger'>*</span>
            </label>
            <input
              type='text'
              id='minimun_duration'
              name='minimun_duration'
              className={`form-control form-control-sm ${
                errors?.minimun_duration &&
                touched?.minimun_duration &&
                "text-danger is-invalid"
              }`}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder='0'
            />
            {errors?.minimun_duration && touched?.minimun_duration && (
              <span className='text-danger'>{errors?.minimun_duration}</span>
            )}
          </div>
        </div>
        <div>
          <div className='col-md-12'>
            <label htmlFor='description' className='form-label'>
              Description
            </label>
            <textarea
              name='description'
              id=''
              cols='30'
              rows='4'
              className='form-control form-control-sm'
              placeholder='Enter descriprion'
              onChange={handleChange}
              onBlur={handleBlur}
            ></textarea>
          </div>
        </div>
        <div className='mt-4 d-flex justify-content-end'>
          <button
            type='submit'
            className='btn btn-primary-1 btn-hover text-white '
          >
            Next <i className='mdi mdi-arrow-right ms-1'></i>
          </button>
        </div>
      </form>
    </>
  );
};

export default CreditGeneralInformation;
